import types from "./languagePairGroupTypes";

export default (state, action) => {
	switch (action.type) {
		case types.SET_LOADING:
			return {
				...state,
				loading: !state.loading
			};
		case types.SET_LANGUAGE_PAIR_GROUPS:
			return {
				...state,
				loading: false,
				languagePairGroups: action.payload
			};
		default:
			return state;
	}
};